import DonutComponent from '../donut/donut'
import { CompensationAmounts } from '@/domain/returns'
import { useTranslation } from 'react-i18next'

interface Props {
  compensationAmounts: CompensationAmounts
  totalCompensation: string
}

export const CompensationsChart: React.FC<Props> = ({
  compensationAmounts,
  totalCompensation
}) => {
  const { t } = useTranslation()

  const labelsCompensations = [
    t('returns_analytics.bank_transfer'),
    t('returns_analytics.opm'),
    t('returns_analytics.store_credit'),
    t('returns_analytics.exchange_same_product'),
    t('returns_analytics.exchange_different_product')
  ]
  const amountsCompensations = [
    compensationAmounts.bankTransfer.amount,
    compensationAmounts.originalPaymentMethod.amount,
    compensationAmounts.storeCredit.amount,
    compensationAmounts.oneOnOneExchanges.amount,
    compensationAmounts.fullCatalogExchanges.amount
  ]
  const valuesCompensations = [
    compensationAmounts.bankTransfer.percentage,
    compensationAmounts.originalPaymentMethod.percentage,
    compensationAmounts.storeCredit.percentage,
    compensationAmounts.oneOnOneExchanges.percentage,
    compensationAmounts.fullCatalogExchanges.percentage
  ]

  return (
    <DonutComponent
      title={t('returns_analytics.title_compensations')}
      labels={labelsCompensations}
      amounts={amountsCompensations}
      values={valuesCompensations}
      totalAmount={totalCompensation}
    />
  )
}
